import { DownOutlined, WarningOutlined } from '@ant-design/icons';
import { ColDef, SelectionChangedEvent } from 'ag-grid-community';
import { DatePicker, PaginationProps, Select, Typography } from 'antd';
import dayjs from 'dayjs';
import { useCallback, useState } from 'react';
import { IOperatorFieldGroup } from '../../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { ConditionGroup, initOperator, IOperator } from '../../AddNewGroup';
import '../../../../style.scss';
import { useCustomerGroupContext } from '../../../../indexV2';
dayjs.locale('vi');

const { RangePicker } = DatePicker;

const { Text } = Typography;

const rowData = [
    {
        maPhieu: "#2524176542",
        hoTen: "Trần Thị Diễm Trang",
        cccd: "079201001234",
        maSoThue: "1234567890",
        ngaySinh: "1995-06-12",
        gioiTinh: "Nữ",
        soDienThoai: "0916892344",
        email: "diemtrang95@gmail.com",
    },
    {
        maPhieu: "#2525549486",
        hoTen: "Đoàn Thanh Sơn",
        cccd: "012345678912",
        maSoThue: "9876543210",
        ngaySinh: "1992-03-25",
        gioiTinh: "Nam",
        soDienThoai: "0913880687",
        email: "son.doan92@gmail.com",
    },
    {
        maPhieu: "#2522411641",
        hoTen: "Nguyễn Văn Năm",
        cccd: "079301009876",
        maSoThue: "4567891230",
        ngaySinh: "1988-11-02",
        gioiTinh: "Nam",
        soDienThoai: "0788945197",
        email: "nam.nguyen88@yahoo.com",
    },
    {
        maPhieu: "#2520685744",
        hoTen: "Lê Minh Huy",
        cccd: "033201007654",
        maSoThue: "1122334455",
        ngaySinh: "1999-01-17",
        gioiTinh: "Nam",
        soDienThoai: "0345241589",
        email: "huy.le99@gmail.com",
    },
    {
        maPhieu: "#2520569227",
        hoTen: "Trần Quốc Quang",
        cccd: "024501003321",
        maSoThue: "6677889900",
        ngaySinh: "1990-08-09",
        gioiTinh: "Nam",
        soDienThoai: "0939115153",
        email: "quang.tran90@hotmail.com",
    },
];

const optionsSelect = [
    {
        value: 1,
        label: 'Bằng'
    },
    {
        value: 2,
        label: 'Trống'
    },
    {
        value: 3,
        label: 'Không trống'
    },
    {
        value: 4,
        label: 'Bắt đầu với'
    },
    {
        value: 5,
        label: 'Kết thúc với'
    },
    {
        value: 6,
        label: 'Nhỏ hơn'
    },

]

// Cấu hình cột
const columnDefs: ColDef[] = [
    { headerName: "Mã định danh khách hàng", field: "maPhieu", flex: 2 },
    { headerName: "Họ tên", field: "hoTen", flex: 2 },
    { headerName: "CCCD/CMND", field: "cccd", flex: 2 },
    { headerName: "Mã số thuế", field: "maSoThue", flex: 2 },
    { headerName: "Ngày sinh", field: "ngaySinh", flex: 2 },
    { headerName: "Giới tính", field: "gioiTinh", flex: 1 },
    { headerName: "Số điện thoại", field: "soDienThoai", flex: 2 },
    { headerName: "Email", field: "email", flex: 3 },
];

export enum CONDITIONGROUP {
    AND = 0,
    OTHER = 1, // tên hiển thị
    ALL = 2, // tên hiển thị
}
interface props {
    sLOperatorFieldGroup: IOperatorFieldGroup[]
    listOperator: IOperator[]
    setListOperator: (value: IOperator[]) => void
}

const AG_PrivateAutomatic: React.FC<props> = ({
    sLOperatorFieldGroup,
    listOperator,
    setListOperator
}) => {
    const [selectedCount, setSelectedCount] = useState(0);

    const [conditionGroup, setConditionGroup] = useState(1);


    const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedCount(selectedRows.length);
    }, []);


    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        // setPaginationTmp(pageNumber);
        // setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
        // gListGroup(pageNumber, pageSize)
    }

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            <div className="custom-page-css w-full flex gap-2 items-center justify-between">
                <span className='custom-page-css text-lg text-344054 font-medium'>Điều kiện nhóm</span>
                <div className="custom-page-css flex items-center gap-2 justify-end">
                    <WarningOutlined className='text-FF4D4F' />
                    <span className='custom-page-css text-base text-FF4D4F font-regular'>(Danh sách khách hàng sẽ thay đổi theo điều kiện)</span>

                </div>

            </div>
            <div className="custom-page-css w-full flex items-center gap-2">
                <div className="custom-page-css flex flex-col gap-2 flex-1 ">
                    <span className='custom-page-css text-base text-344054 font-regular'>Áp dụng cho module</span>
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                        <div className="d-flex align-center  w-full">
                            <Select
                                showSearch
                                allowClear
                                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                                popupClassName='position-dropdow custome-select-item h-popUp'
                                variant="borderless"
                                placeholder="Danh sách khách hàng"
                                suffixIcon={null}
                            // options={cLTypeVehicle}
                            // value={dataFilterList.typeVehicleId}
                            // onChange={(e) => setDataFilterList({ ...dataFilterList, typeVehicleId: e })}
                            />

                        </div>
                        <div className="  h-full d-flex align-center">
                            <DownOutlined className="text-sm text-98A2B3 " />
                        </div>
                    </div>
                </div>
                <div className="custom-page-css flex flex-col gap-2 flex-1 ">
                    <span className='custom-page-css text-base text-344054 font-regular'>Chọn bộ lọc có sẵn</span>
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                        <div className="d-flex align-center  w-full">
                            <Select
                                showSearch
                                allowClear
                                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                                popupClassName='position-dropdow custome-select-item h-popUp'
                                variant="borderless"
                                placeholder="KH sở hữu xe KIA hoặc Mazda và có sinh nhật trong tháng này."
                                suffixIcon={null}
                            // options={cLTypeVehicle}
                            // value={dataFilterList.typeVehicleId}
                            // onChange={(e) => setDataFilterList({ ...dataFilterList, typeVehicleId: e })}
                            />

                        </div>
                        <div className="  h-full d-flex align-center">
                            <DownOutlined className="text-sm text-98A2B3 " />
                        </div>
                    </div>
                </div>

            </div>
            <div className="custom-page-css flex flex-col gap-2 flex-1 ">
                <span className='custom-page-css text-base text-344054 font-regular'>Logic kết hợp các điều kiện lọc</span>
                <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                    <div className="d-flex align-center  w-full">
                        <Select
                            showSearch
                            allowClear
                            className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                            popupClassName='position-dropdow custome-select-item h-popUp'
                            variant="borderless"
                            placeholder="Thỏa mãn tất cả các số điều kiện (AND)"
                            suffixIcon={null}
                            options={ConditionGroup}
                            value={conditionGroup}
                            onChange={(e) => {
                                setConditionGroup(e);
                                setListOperator([{ ...initOperator }]);
                            }}
                        />

                    </div>
                    <div className="  h-full d-flex align-center">
                        <DownOutlined className="text-sm text-98A2B3 " />
                    </div>
                </div>
            </div>

            {/* Tạm tắt */}
            {/* {
                conditionGroup === CONDITIONGROUP.AND ?
                    <ConditionGroupAnd
                        sLOperatorFieldGroup={sLOperatorFieldGroup}
                        listOperator={listOperator}
                        setListOperator={setListOperator}
                    /> :
                    <ConditionGroupOther
                        sLOperatorFieldGroup={sLOperatorFieldGroup}
                        listOperator={listOperator}
                        setListOperator={setListOperator}
                    />
            } */}

            {/* <div className="custom-page-css flex items-center gap-1">
                <span className='custom-page-css text-base text-4B4B4B font-regular'>Đã chọn:</span>
                <span className='custom-page-css text-base text-344054 font-regular'>{selectedCount} khách hàng</span>
            </div>
            <div className="ag-theme-alpine custom-table-ag">
                <AgGridReact
                    domLayout="autoHeight"
                    className="my-auto-height-grid"
                    getRowStyle={(params: any) => ({
                        backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                    })}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    rowHeight={55}
                    defaultColDef={{
                        resizable: true
                    }}
                    rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                       overlayNoRowsTemplate={NodataTable}

                    context={{
                        onSelectedValuesChange: (columnId: string, selectedValues: number[]) => {
                            console.log('Selected values for', columnId, selectedValues);
                            // handleDataFilterChange(columnId, selectedValues);
                            // Xử lý tiếp ở đây: lưu vào state, gọi API, v.v.
                        }
                    }}

                    onSelectionChanged={onSelectionChanged}

                />
            </div>
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                  
                </div>
            </ConfigProvider> */}
        </div>
    )
}

export default AG_PrivateAutomatic
